import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {DocumentTypeService} from '../../services/document-type.service';
import {DocumentType} from '../../model/Entities/DocumentType';
import {Router} from '@angular/router';
import {Contract} from '../../model/Entities/Contract';
import {Document} from '../../model/Entities/Document';

@Component({
    selector: 'document-create-dialog',
    templateUrl: './document-create.dialog.component.html',
    styleUrls: ['./document-create.dialog.component.scss']
})
export class DocumentCreateDialogComponent implements AfterViewInit {
    documentTypes: DocumentType[];
    loading = true;
    contract: Contract = null;
    document: Document = null;

    constructor(public dialog: MatDialogRef<DocumentCreateDialogComponent>,
                private documentTypeService: DocumentTypeService,
                private router: Router,
                @Inject(MAT_DIALOG_DATA) public data: any) {

        this.contract = data.contract;
        this.document = data.document;

    }

    ngAfterViewInit(): void {
        this.documentTypeService.getSimpleList([]).subscribe((data: DocumentType[]) => {
            this.documentTypes = data;
            this.loading = false;
        });
    }

    createDocument(documentType: DocumentType) {
        this.dialog.close(true);
        if (this.contract) {
            this.router.navigate([`/documents/create/${documentType.slug}/${this.contract.id}`]);
        }
        if (this.document) {
            this.router.navigate([`/documents/copy/${documentType.slug}/${this.document.id }`]);
        }
        if (!this.document && !this.contract) {
            this.router.navigate([`/documents/create/${documentType.slug}`]);
        }
     }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentCreateDialogComponent/document-create.dialog.component.ts